import { TermsConditionStatus } from "../../termsandcondition/models/terms-condition.model";

export class PersonProfileModel {
  public personMasterHashId: string;
  public instanceHashId: string;
  public userName: string;
  public firstName: string;
  public lastName: string;
  public middleName: string;
  public countryCode1: string = "";
  public countryCode2: string = "";
  public telephone1: string;
  public telephone2: string;
  public isActive: boolean;
  public personHomeAddressModel: PersonProfileAddressModel;
  public personWorkAddressModel: PersonProfileAddressModel;
  public emailAddressModel: EmailAddressModel;
  public personPassword: string;
  public personConfirmPassword: string;
  public validateLiceanceNumber: boolean = false;
  public dateOfBirth: string;
  public driverLicenceNumber: string;
  public liceanceNumberValidated: boolean;

  public isAccepted: boolean = false;
  public isPrivacyStatementAccepted: boolean = false;
  public allTermsConditionsList: TermsConditionStatus[] = [];
  public termsAndConditionsHashId: string;
  public privacyHashId: string;
  public nifNumber: string;
  public isnifEnabled: boolean = false;
  public driverExternalId: string;
  public instanceLanguage: string;
  public countryCodeHashId:string;
  
  constructor() {
    this.personHomeAddressModel = new PersonProfileAddressModel();
    this.personWorkAddressModel = new PersonProfileAddressModel();
    this.emailAddressModel = new EmailAddressModel();
    this.allTermsConditionsList = [];
  }
}

export class EmailAddressModel {
  public email: string;
}

export class PersonProfileAddressModel {
  public houseNo: string;
  public houseExtention: string;
  public street: string;
  public city: string;
  public zipCode: string;
  public address: string;
  public latitiude: number;
  public logitude: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/personprofile/models/personprofile.model.ts